import React from "react";

import { AVAILABLE_LANGS } from "@typings/globals";

import { useTranslate } from "@hooks/useTranslate";
import { useAuth } from "@hooks/useAuth";
import { useFeatureToggleManager } from "@hooks/useFeatureToggle";

import { Link } from "../../typings/link";
import { TypeOfUser } from "../../typings/typeOfUser";

import { getLinks } from "./useMainNav.helpers";

export const useMainNav = (language: AVAILABLE_LANGS): Link[] => {
  const translate = useTranslate();
  const { isUserLoggedIn, isUserClient } = useAuth();
  const { config } = useFeatureToggleManager();

  const hiddenFor: TypeOfUser = isUserClient ? "client" : "agent";
  const links = getLinks(language, translate);

  let filteredLinks = links.filter(link => {
    if (link.visibleForFeature && !config[link.visibleForFeature]) {
      return false;
    }

    return true;
  });

  if (isUserLoggedIn) {
    filteredLinks = filteredLinks.filter(link => link.hiddenFor !== hiddenFor);
  }

  return filteredLinks;
};
